import { toast } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { partitionReceiptFiles } from "utils/receipts/receiptFileTypes";

/** Keeps the picked files the receipt endpoints accept and names the rest in a toast. */
export const useSupportedReceiptFiles = () => {
  const { t } = useTranslation();
  return (picked: FileList | File[]): File[] => {
    const { supported, rejected } = partitionReceiptFiles(picked);
    if (rejected.length > 0) {
      toast.error(
        rejected.length > 1
          ? t("UnsupportedFileTypesMessage", { files: rejected.join(", ") })
          : t("UnsupportedFileTypeMessage", { file: rejected[0] }),
      );
    }
    return supported;
  };
};
